import { render, staticRenderFns } from "./PpDialog.vue?vue&type=template&id=2b60a3ab"
import script from "./PpDialog.vue?vue&type=script&lang=js"
export * from "./PpDialog.vue?vue&type=script&lang=js"
import style0 from "./PpDialog.vue?vue&type=style&index=0&id=2b60a3ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports